import { useEffect, useState } from 'react'
import { RequestStatus } from '@sales-center/common'
import { fetchAllActivityTypes } from '../../../effects'
import { useActivityTypesContext } from '../../../context'

export function useFetchActivityTypes() {
  const [, dispatch] = useActivityTypesContext()
  const [state, setState] = useState<RequestStatus>('idle')

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setState('loading')

      const action = await fetchAllActivityTypes()

      if (mounted) {
        dispatch(action)
        setState('idle')
      }
    }

    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return state
}
